type AspectRatio = `${number}:${number}`;

export type Env = "dev" | "test" | "prodtest" | "stage" | "prod" | "sandbox" | "local";

export const cloudinaryUrl = (
  imagePath: string,
  env = "prod" as Env,
  maxWidth = 1500,
  aspectRatio?: AspectRatio,
  useRaw?: boolean,
  useSpecialFolder?: string,
) => {
  if (!imagePath) {
    return undefined;
  }

  const folder = useSpecialFolder || "cms";

  if (env == "prodtest" || env == "test" || env == "sandbox") env = "stage";
  if (env == "local") env = "dev";

  if (imagePath.match(/\.svg/i) || useRaw) {
    return `https://res.cloudinary.com/${
      env != "prod" ? `${env}-` : ""
    }banknorwegian/image/upload/v1/${folder}${imagePath}`;
  }

  return `https://res.cloudinary.com/${
    env != "prod" ? `${env}-` : ""
  }banknorwegian/image/upload/${aspectRatioTransform(aspectRatio)}${transform(maxWidth)}/v1/${folder}${imagePath}`;
};

const transform = (maxWidth?: number) =>
  `c_limit,w_auto,f_auto,q_auto${maxWidth !== undefined ? `/c_limit,w_${maxWidth}` : ""}/dpr_auto`;

const aspectRatioTransform = (aspectRatio?: AspectRatio) => (!aspectRatio ? "" : `ar_${aspectRatio},c_fill,g_auto/`);
